import PropTypes from 'prop-types';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import Transition from '../dialogs/Transition';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Zoom from '@material-ui/core/Zoom';
import moment from 'moment';

import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormComponent from '../FormComponent';

//- graphics
import CircularProgress from '@material-ui/core/CircularProgress';
import GreenChecked from '../../images/icons/greenChecked.svg';
import AuthUserContainer from '../../containers/AuthUser';

import TimeClockContainer from '../../containers/TimeClock/TimeClock';
import Note from '../Note';
import EnhancedTable from '../table/EnhancedTable';
import ErrorIcon from '@material-ui/icons/Error';
import { red } from '@material-ui/core/colors';

function styles() {
	return {
		inner: {
			padding: '40px 30px',
		},
		dialogTitle: {
			fontSize: 24,
			borderBottom: '1px solid #eee',
			paddingBottom: 5,
			marginBottom: 10,
			fontWeight: 300,
			display: 'flex',
			justifyContent: 'space-between',
		},
		whatToExport: {
			fontSize: 18,
			marginTop: 10,
			marginBottom: 10,
		},
		dialogRoot: {
			//overflow: 'visible'
			alignItems: 'end',
		},
		closeButton: {
			position: 'absolute',
			right: 15,
			top: 15,
			color: '#555',
		},
		addButton: {
			//verticalAlign : 'middle',
			//textDecoration: 'none',
			//marginBottom: 0,
			//borderRadius: 100,
			padding: '10px 35px',
			fontSize: 16,
			marginTop: 20,
			color: 'white',
			marginRight: 10,
		},
		greenCheckedIcon: {
			display: 'inline-block',
			width: 33,
			height: 33,
			backgroundImage: `url('${GreenChecked}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 2,
			marginLeft: 5,
		},
		isExporting: {
			marginLeft: 20,
			fontSize: 16,
			color: '#1565C0',
		},
		exportingSuccessful: {
			marginLeft: 20,
			fontSize: 16,
			color: '#2E7D32',
		},
		pleaseSelect: {
			fontStyle: 'italic',
			color: '#777',
		},
		currentShiftContainer: {
			border: `1px solid #eee`,
			backgroundColor: '#fcfcfc',
			padding: `20px 20px`,
			margin: '20px 0px',
			borderRadius: 5,
		},
		currentShiftTitle: {
			display: 'flex',
			alignItems: 'center',
			fontSize: 17,
		},
		errorIcon: {
			color: '#F44336',
			marginRight: 10,
		},
		currentLabel: {
			color: '#666',
			marginLeft: 30,
			marginRight: 5,
		},
		currentValue: {
			fontWeight: 500,
		},
		miniErrorIcon: {
			width: 30,
			height: 30,
			color: red[400],
			marginLeft: 0,
			marginTop: 0,
			marginRight: 5,
			verticalAlign: 'middle',
		},
	};
}

class ExponentExportConfirmation extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			isExporting: false,
			exportingSuccessful: false,
			clockInDate: moment().format('YYYY-MM-DD'),
		};
	}

	componentDidUpdate(prevProps, prevState, snapshot) {}

	handleExport = () => {
		const { timeClockShiftExponentExport, showErrors, searchApiParams = {} } = this.props;

		const params = {};
		['accessToken', 'shiftForUserIds', 'afterDateTime', 'beforeDateTime'].forEach((key) => {
			if (searchApiParams[key]) {
				params[key] = searchApiParams[key];
			}
		});

		this.setState({ isExporting: true, exportingSuccessful: false });

		timeClockShiftExponentExport({
			params,
			callback: (err) => {
				this.setState({ isExporting: false });
				if (err) {
					return showErrors(_.isArray(err) ? err : [err]);
				}
				this.setState({ exportingSuccessful: true });
			},
		});
	};

	handleClose = () => {
		this.setState({
			exportingSuccessful: false,
			isExporting: false,
		});
		this.props.onClose();
	};

	render() {
		const { open, classes, timeClockShiftRows, searchApiParams = {} } = this.props;

		const { isExporting, exportingSuccessful } = this.state;

		if (!timeClockShiftRows) {
			return null;
		}

		let numberOfFlaggedShifts = 0;
		let numberOfPendingShifts = 0;
		let numberOfClockedInShifts = 0;

		timeClockShiftRows.forEach((timeClockShiftRow) => {
			const { auditStatus, clockOutDateTime } = timeClockShiftRow;

			if (!clockOutDateTime) {
				numberOfClockedInShifts++;
				return;
			}

			if (auditStatus === 'PENDING') {
				numberOfPendingShifts++;
			}

			if (auditStatus === 'ERROR' || auditStatus === 'WARNING') {
				numberOfFlaggedShifts++;
			}
		});
		const totalResults = timeClockShiftRows ? timeClockShiftRows.length : 0;

		const canNotExport =
			numberOfFlaggedShifts ||
			numberOfPendingShifts ||
			numberOfClockedInShifts ||
			totalResults === 0;

		const note = `
		Please make sure all shifts look accurate before exporting. After shifts are exported
		any changes can only be made by a Sphere Admin and all changes need to happen in ExponentHR and
		in Sphere.
		`;

		const { shiftForUserIds, afterDate, beforeDate } = searchApiParams;

		let whatToExport;
		if (_.isEmpty(shiftForUserIds) && !afterDate && !beforeDate) {
			whatToExport = 'Exporting all shifts not already exported';
		} else {
			whatToExport = (
				<div>
					<div>Exporting shifts for the following:</div>
					{!_.isEmpty(shiftForUserIds) && <div>Employees : {shiftForUserIds.length}</div>}
					{afterDate && <div>After : {moment(afterDate).format('M/D')}</div>}
					{beforeDate && <div>Before : {moment(beforeDate).format('M/D')}</div>}
				</div>
			);
		}

		return (
			<Dialog
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				fullWidth={true}
				maxWidth={'lg'}
				classes={{ scrollPaper: classes.dialogRoot }}
			>
				<div className={classes.inner}>
					<div className={classes.dialogTitle}>
						<div>
							<strong>{totalResults}</strong> shifts to be exported
						</div>
						<div>
							<IconButton
								aria-label="close"
								className={classes.closeButton}
								onClick={this.handleClose}
							>
								<CloseIcon />
							</IconButton>
						</div>
					</div>

					<div className={classes.whatToExport}>{whatToExport}</div>

					<form>
						<Grid container spacing={2} style={{ marginTop: 0, marginBottom: 0 }}>
							{!canNotExport && (
								<Grid item md={12}>
									<Note label={note} />
								</Grid>
							)}

							{!!numberOfClockedInShifts && (
								<Grid item md={12}>
									<Note>
										<div style={{ display: 'flex' }}>
											<ErrorIcon className={classes.miniErrorIcon} />
											<div>
												<strong>Export Blocked</strong> You can not export these shifts because you
												have {numberOfClockedInShifts} shifts still clocked in during this date
												range. Wait until those shifts have been completed.
											</div>
										</div>
									</Note>
								</Grid>
							)}

							{totalResults === 0 && (
								<Grid item md={12}>
									<Note>
										<div style={{ display: 'flex' }}>
											<ErrorIcon className={classes.miniErrorIcon} />
											<div>
												<strong>Export Blocked</strong> There aren't any shifts to export.
											</div>
										</div>
									</Note>
								</Grid>
							)}

							{!!numberOfFlaggedShifts && (
								<Grid item md={12}>
									<Note>
										<div style={{ display: 'flex' }}>
											<ErrorIcon className={classes.miniErrorIcon} />
											<div>
												<strong>Export Blocked</strong> You can not export these shifts because you
												have <strong>{numberOfFlaggedShifts}</strong> flagged as WARNING / ERROR and
												must be corrected and cleared before you can export
												<br />
												<br />
												<a href="/timeClock/shiftAudit">
													Click here to visit the Shift Audit and fix these.
												</a>
											</div>
										</div>
									</Note>
								</Grid>
							)}

							{!!numberOfPendingShifts && (
								<Grid item md={12}>
									<Note>
										<div style={{ display: 'flex' }}>
											<ErrorIcon className={classes.miniErrorIcon} />
											<div>
												<strong>Export Blocked</strong> You can not export these shifts because you
												have <strong>{numberOfPendingShifts}</strong> shifts still waiting to be
												audited. This is usually because we wait until the end of the day to full
												PASS a shift.
											</div>
										</div>
									</Note>
								</Grid>
							)}

							<Grid item md={12} style={{ display: 'flex', alignItems: 'baseline' }}>
								<Button
									variant="contained"
									color="primary"
									className={classes.addButton}
									onClick={this.handleExport}
									disabled={isExporting || exportingSuccessful || canNotExport}
								>
									Export to ExponentHR
								</Button>

								<Button variant="outlined" className={classes.button} onClick={this.handleClose}>
									Close
								</Button>

								<Zoom
									in={isExporting}
									style={{ transitionDelay: isExporting ? '0ms' : '0ms' }}
									mountOnEnter
									unmountOnExit
								>
									<div className={classes.isExporting}>
										<CircularProgress style={{ verticalAlign: 'middle' }} />
										<span style={{ paddingLeft: 10 }}>Exporting...</span>
									</div>
								</Zoom>

								<Zoom
									in={exportingSuccessful}
									style={{
										transitionDelay: exportingSuccessful ? '250ms' : '0ms',
									}}
								>
									<div className={classes.exportingSuccessful}>
										<div className={classes.greenCheckedIcon} />
										<span style={{ paddingLeft: 10 }}>Exported to ExponentHR successfully.</span>
									</div>
								</Zoom>
							</Grid>
						</Grid>

						<hr style={{ marginTop: 20, magrinBottom: 20 }} />

						<Grid item md={12}>
							<div className={classes.dialogTitle}>Shifts included in export</div>
							{this.renderResults()}
						</Grid>
					</form>
				</div>
			</Dialog>
		);
	}

	renderResults = () => {
		const { timeClockShiftRows } = this.props;

		const columns = [
			{ label: 'Employee', sortId: 'userDisplay', displayId: 'userDisplay' },
			{
				label: 'Clock In',
				sortId: 'clockInDateTime',
				displayId: 'clockInDateTimeDisplay',
			},
			{
				label: 'Clock Out',
				sortId: 'clockOutDateTime',
				displayId: 'clockOutDateTimeDisplay',
			},
			{
				label: 'Duration',
				sortId: 'durationDiff',
				displayId: 'durationDisplay',
			},
			{
				label: 'Details',
				sortId: 'details',
				displayId: 'timeClockShiftEventsFormatted',
			},
			{ label: 'Audit', sortId: 'auditStatus', displayId: 'auditStatus' },
			{ label: 'Update', sortId: 'update', displayId: 'updateButton' },
		];

		return (
			<EnhancedTable
				rows={timeClockShiftRows}
				columns={columns}
				isDense={true}
				defaultOrderBy={'clockInDateTime'}
				defaultOrder={'desc'}
			/>
		);
	};
}

ExponentExportConfirmation.propTypes = {
	open: PropTypes.bool,
	onClose: PropTypes.func,
	timeClockShiftRows: PropTypes.array,
	searchApiParams: PropTypes.object,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	TimeClockContainer,
])(ExponentExportConfirmation);
